module.exports = __webpack_public_path__ + "static/media/menuStopwatch.1241fbb0.svg";